import { fromJS } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import * as service from 'services/admin.services';
import { updateUserAttributes, isSessionValid } from 'services/session.service';
import {
    SESSION_VALID,
    SESSION_LOGOUT,
} from '../../components/Session/SessionActionTypes';
import {
  SEARCH_USER_REQUESTED,
  SEARCH_USER_FAILED,
  SEARCH_USER_SUCCESSFUL,
  GET_COACH_APPLICATIONS_REQUESTED,
  GET_COACH_APPLICATIONS_SUCCESSFUL,
  GET_COACH_APPLICATIONS_FAILED,
  COACH_APPLICATION_UPGRADE_REQUESTED,
  COACH_APPLICATION_UPGRADE_FAILED,
  COACH_APPLICATION_UPGRADE_SUCCESSFUL,
  START_LOADER,
  STOP_LOADER,
  OVERRIDE_STUDENT_SUCCESSFUL,
  UPGRADE_STUDENT_SUCCESSFUL,
  STUDENT_EVALUATION_SUCCESSFUL,
  DELETE_COACH_SUCCESSFUL,
  ADD_COACH,
  MODIFY_COLLEGE,
  GET_COACHES_FROM_DB,
  ADD_COLLEGE_SUCCESSFUL,
  GET_STUDENTS_FOR_STUDENT_EXPLORER,
  DELETE_COACH_APPLICATION_SUCCESSFUL,
  RESET_STUDENT_DASHBOARD_SUCCESSFUL,
  // START_ES_LOADER,
  // STOP_ES_LOADER,
  // GET_ES_STUDENTS_FOR_STUDENT_EXPLORER,
  SEARCH_ES_USER_REQUESTED,
  SEARCH_ES_USER_FAILED,
  SEARCH_ES_USER_SUCCESSFUL,
} from './actionTypes';

export function SearchUser(payload,role) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: SEARCH_USER_REQUESTED,
    });
    service.searchUser(payload, role)
            .then((result) => {
              let res = result.hits;

              if (res.hits.length > 0) {
                res = res.hits[0]._source; // eslint-disable-line
                let currentId = '';
                if (role === 'STUDENT') {
                  currentId = res.id;
                } else {
                  currentId = res.coach_id;
                }
                const temp = [{ Name: 'profile', Value: currentId }];
                updateUserAttributes(temp, (err) => {
                  if (!err) {
                    isSessionValid((sessionErr, sessionResult) => {
                      if (sessionErr) {
                        dispatch({
                          type: SESSION_LOGOUT,
                        });
                      } else {
                        const token = sessionResult.session.idToken.jwtToken;
                        dispatch({
                          type: SESSION_VALID,
                          session: fromJS(sessionResult.session),
                          user: fromJS(sessionResult.user),
                          attributes: fromJS(sessionResult.attributes),
                          token,
                        });
                        if (result) {
                          dispatch({
                            type: SEARCH_USER_SUCCESSFUL,
                            data: fromJS(result),
                          });
                        }
                      }
                    });
                  }
                });
              } else {
                dispatch({
                  type: SEARCH_USER_FAILED,
                  error: 'User not found',
                });
              }
            })
            .catch((err) => {
              dispatch({
                type: SEARCH_USER_FAILED,
                error: err,
              });
            });
  };
}

export function getCoachApplications(id) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: GET_COACH_APPLICATIONS_REQUESTED,
    });
    service.getCoachApplications(id)
            .then((result) => {
              if (result) {
                dispatch({
                  type: GET_COACH_APPLICATIONS_SUCCESSFUL,
                  data: fromJS(result),
                });
              }
            })
            .catch((err) => {
              dispatch({
                type: GET_COACH_APPLICATIONS_FAILED,
                error: err,
              });
            });
  };
}

export function upgradeCoachApplication(payload) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: COACH_APPLICATION_UPGRADE_REQUESTED,
    });
    service.updateCoachApplication(payload)
            .then((result) => {
              if (result) {
                dispatch({
                  type: COACH_APPLICATION_UPGRADE_SUCCESSFUL,
                  data: fromJS(result),
                });
              }
            })
            .catch((err) => {
              dispatch({
                type: COACH_APPLICATION_UPGRADE_FAILED,
                error: err,
              });
            });
  };
}

export function upgradeStudent(payload) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: START_LOADER,
    });
    service.upgradeStudent(payload)
      .then((result) => {
        if (result) {
          dispatch({
            type: UPGRADE_STUDENT_SUCCESSFUL,
            data: fromJS(result),
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: STOP_LOADER,
          error: err,
        });
      });
  };
}

export function overrideStudent(payload) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: START_LOADER,
    });
    service.overrideStudent(payload)
      .then((result) => {
        if (result) {
          dispatch({
            type: OVERRIDE_STUDENT_SUCCESSFUL,
            data: fromJS(result),
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: STOP_LOADER,
          error: err,
        });
      });
  };
}

export function evaluateStudent(payload) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: START_LOADER,
    });
    service.evaluateStudent(payload)
      .then((result) => {
        if (result) {
          dispatch({
            type: STUDENT_EVALUATION_SUCCESSFUL,
            data: fromJS(result),
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: STOP_LOADER,
          error: err,
        });
      });
  };
}

export const resetStudentDashboard = studentId => (dispatch) => {
  // console.log(studentId);
  dispatch({
    type: START_LOADER,
  });
  service.resetStudentDashboard(studentId)
    .then((result) => {
      dispatch({
        type: RESET_STUDENT_DASHBOARD_SUCCESSFUL,
        result,
      });
    })
    .catch((err) => {
      dispatch({
        type: STOP_LOADER,
        error: err,
      });
    });
};

export function deleteCoach(payload) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: START_LOADER,
    });
    service.deleteCoach(payload)
      .then((result) => {
        if (result) {
          dispatch({
            type: DELETE_COACH_SUCCESSFUL,
            data: fromJS(result),
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: STOP_LOADER,
          error: err,
        });
      });
  };
}

export function deleteCoachApplication(id) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: START_LOADER,
    });
    service.deleteCoachApplication(id)
      .then((result) => {
        if (result) {
          dispatch({
            type: DELETE_COACH_APPLICATION_SUCCESSFUL,
            id,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: STOP_LOADER,
          error: err,
        });
      });
  };
}

export function addCoach(payload) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: START_LOADER,
    });
    service.addCoach(payload)
      .then((result) => {
        if (result) {
          dispatch({
            type: ADD_COACH,
            data: fromJS(result),
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: STOP_LOADER,
          error: err,
        });
      });
  };
}

export function modifyCollege(payload) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: START_LOADER,
    });
    service.modifyCollege(payload)
      .then((result) => {
        if (result) {
          dispatch({
            type: MODIFY_COLLEGE,
            data: fromJS(result),
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: STOP_LOADER,
          error: err,
        });
      });
  };
}

export function getCoachesFromColleges(payload) {
  return (dispatch) => {
    dispatch({
      type: START_LOADER,
    });
    service.getCoachesFromColleges(payload)
      .then((result) => {
        if (result) {
          dispatch({
            type: GET_COACHES_FROM_DB,
            data: fromJS(result),
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: STOP_LOADER,
          error: err,
        });
      });
  };
}

export function addCollegeToDB(payload) {
  return (dispatch) => {
    dispatch({
      type: START_LOADER,
    });
    service.addCollegeToDB(payload)
      .then((result) => {
        if (result) {
          dispatch({
            type: ADD_COLLEGE_SUCCESSFUL,
            data: fromJS(result),
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: STOP_LOADER,
          error: err,
        });
      });
  };
}

export function resetValues(action) {
  return (dispatch) => {
    dispatch({
      type: action,
    });
  };
}

export function getStudentForStudentExplorer(payload) {
  return (dispatch) => {
    dispatch({
      type: START_LOADER,
    });
    service.getStudentForStudentExplorer(payload)
      .then((result) => {
        if (result) {
          dispatch({
            type: GET_STUDENTS_FOR_STUDENT_EXPLORER,
            data: fromJS(result.hits.hits),
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: STOP_LOADER,
          error: err,
        });
      });
  };
}

// export function SearchUserByFullName(payload) {
//   return (dispatch) => {
//     dispatch({
//       type: START_ES_LOADER,
//     });
//     service.getStudentForStudentExplorer(payload)
//       .then((result) => {
//         if (result) {
//           dispatch({
//             type: GET_ES_STUDENTS_FOR_STUDENT_EXPLORER,
//             data: fromJS(result.hits.hits),
//           });
//         }
//       })
//       .catch((err) => {
//         dispatch({
//           type: STOP_ES_LOADER,
//           error: err,
//         });
//       });
//   };
// }

// export function SearchAtheleteByName(payload) {
//   // eslint-disable-next-line no-console
//   console.log('Action');
//   return (dispatch) => {
//     dispatch({
//       type: SEARCH_ES_USER_REQUESTED,
//     });
//     service.getStudentForStudentExplorer(payload)
//             .then((result) => {
//               let res = result.hits;

//               if (res.hits.length > 0) {
//                 res = res.hits[0]._source; // eslint-disable-line
//                 let currentId = '';
//                 currentId = res.id;
//                 const temp = [{ Name: 'profile', Value: currentId }];
//                 updateUserAttributes(temp, (err) => {
//                   if (!err) {
//                     isSessionValid((sessionErr, sessionResult) => {
//                       if (sessionErr) {
//                         dispatch({
//                           type: SESSION_LOGOUT,
//                         });
//                       } else {
//                         const token = sessionResult.session.idToken.jwtToken;
//                         dispatch({
//                           type: SESSION_VALID,
//                           session: fromJS(sessionResult.session),
//                           user: fromJS(sessionResult.user),
//                           attributes: fromJS(sessionResult.attributes),
//                           token,
//                         });
//                         if (result) {
//                           dispatch({
//                             type: SEARCH_ES_USER_SUCCESSFUL,
//                             data: fromJS(result.hits.hits),
//                           });
//                         }
//                       }
//                     });
//                   }
//                 });
//               } else {
//                 dispatch({
//                   type: SEARCH_ES_USER_FAILED,
//                   error: 'User not found',
//                 });
//               }
//             })
//             .catch((err) => {
//               dispatch({
//                 type: SEARCH_ES_USER_FAILED,
//                 error: err,
//               });
//             });
//   };
// }

export function SearchAtheleteByName(payload) {
  return (dispatch) => {
    dispatch({
      type: SEARCH_ES_USER_REQUESTED,
    });
    service.getStudentForStudentExplorer(payload)
      .then((result) => {
        if (result) {
          dispatch({
            type: SEARCH_ES_USER_SUCCESSFUL,
            data: fromJS(result.hits.hits),
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: SEARCH_ES_USER_FAILED,
          error: err,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/containers/Admin/actions.js